import React from "react";

const CheckboxIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33331 3.99992C1.33331 2.52716 2.52722 1.33325 3.99998 1.33325H12C13.4727 1.33325 14.6666 2.52716 14.6666 3.99992V11.9999C14.6666 13.4727 13.4727 14.6666 12 14.6666H3.99998C2.52722 14.6666 1.33331 13.4727 1.33331 11.9999V3.99992ZM3.99998 2.66659C3.2636 2.66659 2.66665 3.26354 2.66665 3.99992V11.9999C2.66665 12.7363 3.2636 13.3333 3.99998 13.3333H12C12.7364 13.3333 13.3333 12.7363 13.3333 11.9999V3.99992C13.3333 3.26354 12.7364 2.66659 12 2.66659H3.99998Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default CheckboxIcon;
